export class RequestChildElement {
    RequestChildElementKey: string;
    RequestChildElementValue: string[];
}
